<template>
  <div class="bg">
    <v-form v-model="valid" ref="form" class="pt-16">
      <v-row class="justify-center">
        <v-col cols="12" md="6" sm="8">
          <v-card elevation="1" class="mx-auto rounded-lg">
            <v-row class="justify-center">
              <v-col cols="12" md="10" sm="10" class="pb-16 px-8">
                <div class="text-center mt-2">
<!--                  <v-icon x-large color="green">mdi-email-outline</v-icon>-->
                  <v-icon x-large color="green">mdi-whatsapp</v-icon>
                </div>
                <div class="d-flex flex-column mt-4 font-weight-bold subtitle-1 text-center">
                  REGISTRATION
                </div>
                <v-divider></v-divider>
                <div class="mt-4 mx-4 subtitle-2 font-weight-regular text-center">
                  Kode Verifikasi telah dikirim ke nomer Whatsapp {{ itemFtReg.firstName }} {{itemFtReg.lastName}}
                </div>
                <div class=" mx-6 subtitle-2 font-weight-light">
                  Silahkan periksa di pesan masuk whatsapp anda
                </div>
                <div class="otp-container mt-4">
                  <input type="text"
                         v-model="user.otp"
                         @input="validateOtp"
                         class="otp-input"
                         :disabled="counter <= 0"
                         maxlength="6" placeholder="Enter OTP">
                </div>
                <div class="text-center grey--text mt-2 subtitle-2">
                  Time left: {{ counter }} seconds
                </div>

                <div class="mt-8"></div>
                <div class="text-center" v-if="errorMessage">
                  <span class="red--text">
                    {{ errorMessage}}.
                  </span>
                  <span>
                    <router-link :to="{ path: '/register'}" color="white" plain class="blue--text" style="text-transform: none !important; text-decoration: none">
                      Try Again?
                    </router-link>
                  </span>
                </div>
                <v-divider></v-divider>
                <div class="text-center grey--text mt-2 subtitle-2">
                  DPMPTSP KABUPATEN LUMAJANG 2025
                </div>

              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import User from "@/models/user";
import FtRegistrationRegService from "@/services/apiservices-account-registration/ft-registration-reg-service";

export default {
  name: "RegistrationMasukanOtp",
  components: {},
  data() {
    return {
      valid: false,
      rulesMinLength: (v) => {
        return (v && v.length >=5) || "Must be at least 5 characters long";
      },
      errorMessage: "",
      user: new User("", ""),
      counter: 200,

    };
  },
  computed: {
    itemFtReg(){
      return this.$store.state.registration.itemFtReg
    }
  },
  created() {
  },
  methods: {
    validateOtp() {
      if (this.user.otp.length === 5 &&  this.counter > 0) {
        /**
         * 1. Cek OTP to Database
         * 2. if OTP is valid, then redirect to Account isActivate
         */
        FtRegistrationRegService.regValidateOtp(this.itemFtReg.ref, this.user.otp)
            .then((response) => {
              if (response.status === 200 && response.data.status.includes('valid')) {
                this.$router.push("/registation-active");

              }
            })
            .catch((error) => {
              if (error.response.data.message.includes('error: OTP is invalid')){
                this.errorMessage = "OTP is invalid";
              }else if (error.response.data.message.includes('error: OTP is expired')){
                this.errorMessage = "OTP is expired";
              }

            });

      }
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.counter > 0) {
          this.counter--;
        } else {
          clearInterval(this.interval);
          this.errorMessage = "Session is expired";
        }
      }, 1000);
    },

    formatToThreeDigits(time) {
      const isoString = typeof time === 'string' ? time : time.toISOString();
      const [date, timePart] = isoString.split('T');
      const [timeComponent, offset] = timePart.split(/[+-]/);
      const formattedTimeComponent = timeComponent.length > 8 ? timeComponent.slice(0, 8) + '.' + timeComponent.slice(9, 12) : timeComponent;
      return `${date}T${formattedTimeComponent}${offset ? isoString.slice(isoString.indexOf(offset) - 1) : ''}`;
    },
    toISOWithOffset(date) {
      const tzo = -date.getTimezoneOffset(),
          dif = tzo >= 0 ? '+' : '-',
          pad = function(num) {
            return (num < 10 ? '0' : '') + num;
          };

      return date.getFullYear() +
          '-' + pad(date.getMonth() + 1) +
          '-' + pad(date.getDate()) +
          'T' + pad(date.getHours()) +
          ':' + pad(date.getMinutes()) +
          ':' + pad(date.getSeconds()) +
          '.' + (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
          dif + pad(Math.floor(Math.abs(tzo) / 60)) +
          ':' + pad(Math.abs(tzo) % 60);
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {

    const start = this.toISOWithOffset(new Date());
    const timeEnd = this.toISOWithOffset(new Date(this.itemFtReg.timeEnd));

    const formattedStart = this.formatToThreeDigits(start);
    const formattedTimeEnd = this.formatToThreeDigits(timeEnd);

    const dateStart = new Date(formattedStart);
    const dateEnd = new Date(formattedTimeEnd);

    // Hitung selisih dalam milidetik
    this.diffInMilliseconds = dateEnd - dateStart;
    // console.log("Difference in milliseconds:", this.diffInMilliseconds/1000);

    if (this.diffInMilliseconds <= 0) {
      this.counter = 0
    }else {
      this.counter = Math.round(this.diffInMilliseconds/1000);
    }

    this.startCountdown();

  },
};
</script>

<style scoped>

.bg {
  background: #edf1f3;
  width: 100%;
  height: 100vh;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh;
  background-color: #f0f8ff;
}

.otp-input {
  width: 300px;
  padding: 10px 15px;
  font-size: 18px;
  border: 2px solid #ccc;
  border-radius: 8px;
  transition: all 0.3s ease;
  text-align: center;
  letter-spacing: 2px;
}

.otp-input:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
}

</style>


